import { IConfig } from '@cian/config/shared';

export const isMessageAssumptionsEnabled = (config: IConfig): boolean => {
  return Boolean(config.get<boolean>('frontend-chats.MessageAssumptions.Enabled'));
};
